module.exports = __webpack_public_path__ + "img/banner-2-en.691bd175.png";